export interface FormRadioButtonItems {
  className?: string
  children?: React.ReactNode
}

export function FormRadioButtonItems({
  className,
  children,
}: FormRadioButtonItems) {
  return (
    <div className={`${className} flex w-full flex-row gap-3`}>{children}</div>
  )
}

export default FormRadioButtonItems
